import React from "react";
import SubscriptionProvider from "../subscriptionContext";
import SubscriptionDetailsPage from "./SubscriptionDetailsPage";
import "./assets/subscriptionStyles.css";

const SubscriptionDetails = ({ id }) => {
  return (
    <SubscriptionProvider subscriptionId={id} key={id}>
      <SubscriptionDetailsPage />
    </SubscriptionProvider>
  );
};

export default SubscriptionDetails;
